import { useEffect } from 'react';

type Props = {
  shouldLoad: boolean;
};

export default function ThirdPartyScripts({ shouldLoad }: Props) {
  // Ensure Chameleon stub exists synchronously so calls like chmln.identify() don't throw
  try {
    const w = window as any;
    const c = 'chmln';
    if (!w[c]) w[c] = {};
    const methods = 'identify alias track clear set show on off custom help _data'.split(' ');

    for (let i = 0; i < methods.length; i++) {
      const name = methods[i];
      const queueName = name + '_a';
      if (!w[c][queueName]) w[c][queueName] = [];

      if (typeof w[c][name] !== 'function') {
        w[c][name] = function (...args: any[]) {
          w[c][queueName].push(args);
        };
      }
    }
  } catch {
    // no-op
  }

  useEffect(() => {
    if (!shouldLoad) return;

    let loaded = false;
    const loadChameleon = () => {
      if (loaded) return;
      loaded = true;
      window.removeEventListener('pointerdown', loadChameleon);
      window.removeEventListener('keydown', loadChameleon);
      window.clearTimeout(fallbackTimer);

      try {
        const w = window as any;
        const d = document;
        const token = 'SoR7iSTKYtGrupGnBpk3dZFDzsZUmmhjrlPdakdGZUMoq9-1LSOFV-CX79xgwVNSfw9gQH';
        const key = 'chmln';
        if (!w[key]) w[key] = {};

        if (!d.getElementById('chmln-loader')) {
          w[key].accountToken = token;
          w[key].location = w.location.href.toString();
          w[key].now = new Date();
          const script = d.createElement('script');
          script.id = 'chmln-loader';
          script.async = true;
          script.fetchPriority = 'low';
          script.src = `https://fast.trychameleon.com/messo/${token}/messo.min.js`;
          d.head.appendChild(script);
        }
      } catch {}
    };

    // Keep onboarding/help off the critical rendering path. Its synchronous
    // stub above queues calls until the first interaction, with a fallback for
    // users who leave the page open without interacting.
    const fallbackTimer = window.setTimeout(loadChameleon, 15_000);
    window.addEventListener('pointerdown', loadChameleon, { once: true, passive: true });
    window.addEventListener('keydown', loadChameleon, { once: true });

    return () => {
      window.clearTimeout(fallbackTimer);
      window.removeEventListener('pointerdown', loadChameleon);
      window.removeEventListener('keydown', loadChameleon);
    };
  }, [shouldLoad]);

  return null;
}
